<template lang="html">
  <div class="extension-edit">
    <div
      v-if="error"
      class="alert alert-danger text-center"
      role="alert">
      {{ error.message }}
    </div>
    <div class="card">
      <div class="card-header">
        <h3>Você está editando o ramal {{ extension }}</h3>
      </div>
      <div class="card-body">
        <form
          ref="editExtensionForm"
          class="text-center"
          @submit.prevent="onSubmit"
          @keydown.enter.prevent="onSubmit">
          <ul
            class="nav nav-tabs"
            role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                data-toggle="tab"
                href="#identity"
                role="tab"
                aria-controls="identity"
                aria-selected="true">Dados</a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#integrations"
                role="tab"
                aria-controls="integrations"
                aria-selected="false">Integrações</a>
            </li>
          </ul>
          <div class="tab-content">
            <div
              class="tab-pane fade show active"
              id="identity"
              role="tabpanel"
              aria-labelledby="identity-tab">
              <div class="form-group row">
                <label
                  for="extension"
                  class="col-sm-4 col-form-label">Ramal</label>
                <div class="col-sm-8">
                  <input
                    id="extension"
                    type="text"
                    class="form-control"
                    autocomplete="extension"
                    v-model="extension"
                    disabled>
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="password"
                  class="col-sm-4 col-form-label">Senha</label>
                <div class="col-sm-8">
                  <div class="input-group">
                    <input
                      id="password"
                      type="password"
                      class="form-control"
                      autocomplete="new-password"
                      v-model="password"
                      required>
                    <span class="input-group-append">
                      <a
                        class="input-group-text"
                        href="#"
                        @click.prevent="togglePasswordVisibility()">
                        <i class="ik ik-eye" />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="bina"
                  class="col-sm-4 col-form-label">BINA - Número exibido na chamada</label>
                <div class="col-sm-8">
                  <input
                    id="bina"
                    type="text"
                    class="form-control"
                    v-model="bina">
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="firstName"
                  class="col-sm-4 col-form-label">Nome do contato</label>
                <div class="col-sm-8">
                  <input
                    id="firstName"
                    type="text"
                    class="form-control"
                    v-model="firstName">
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="lastName"
                  class="col-sm-4 col-form-label">Sobrenome do contato</label>
                <div class="col-sm-8">
                  <input
                    id="lastName"
                    type="text"
                    class="form-control"
                    v-model="lastName">
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="email"
                  class="col-sm-4 col-form-label">Email do contato</label>
                <div class="col-sm-8">
                  <input
                    id="email"
                    type="text"
                    class="form-control"
                    v-model="email">
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="recordWrite"
                  class="col-sm-4 col-form-label">Este ramal deve gravar as chamadas?</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="recordWrite"
                    v-model="recordWrite"
                    required>
                    <option
                      v-for="option in yesNoOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="integrations"
              role="tabpanel"
              aria-labelledby="integrations-tab">
              <div class="form-group row">
                <label
                  for="integration"
                  class="col-sm-4 col-form-label">Ao finalizar uma chamada os dados e gravação devem ser enviados para</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="integration"
                    v-model="integration"
                    @change="onChangeIntegration">
                    <option
                      v-for="option in integrationsOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div
                  class="col-sm-12"
                  id="extras">
                  <div
                    id="collapsePiperun"
                    aria-labelledby="collapsePiperun"
                    data-parent="#extras"
                    :class="{ collapse: true, show: showIntegrationPiperunCollapse }">
                    <div class="align-content-center">
                      <p>
                        Para configurar o Click to Call
                        <a
                          href="https://ajuda.crmpiperun.com/pt-br/articles/53-configuracoes-de-telefonia-voip-com-parceiros-homologados"
                          target="_blank"
                          class="link">siga os passos deste artigo</a>
                        da Central de Ajuda PipeRun CRM.
                      </p>
                      <p>
                        Para facilitar sua vida
                        <a
                          class="copy-url-piperun link"
                          data-clipboard-text="https://api.api4com.com/api/v1/integrations/piperun/click-to-call"
                          title="https://api.api4com.com/api/v1/integrations/piperun/click-to-call"
                          @click.prevent="copyToClipboard">
                          clique aqui para copiar a URL
                        </a>
                        que será utilizada na configuração do Click to Call.
                      </p>
                      <div class="embed-responsive embed-responsive-16by9 text-center">
                        <iframe
                          class="embed-responsive-item"
                          src="https://www.youtube.com/embed/H9bxwp_17h0"
                          allowfullscreen />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="buttons flex">
            <button
              class="btn btn-outline-secondary"
              @click.prevent="onCancel">
              Voltar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              @click.prevent="onSubmit">
              Atualizar
            </button>
          </div>
        </form>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="editExtensionSuccess"
      ref="editExtensionSuccess"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5>Seu ramal foi atualizado com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'

export default {
  name: 'ExtensionEdit',
  data () {
    return {
      error: null,
      id: null,
      extension: null,
      password: null,
      bina: null,
      firstName: null,
      lastName: null,
      email: null,
      recordWrite: null,
      webhook_url: null,
      webhook_body_version: null,
      yesNoOptions: [
        { text: 'Sim', value: 1 },
        { text: 'Não', value: 0 }
      ],
      showIntegrationPiperunCollapse: false,
      integration: 'none',
      integrationsOptions: [],
      gatewayAttrs: {
        'none': {
          text: 'Nenhuma Integração',
          webhookUrl: null,
          webhookVersion: null
        },
        'piperun': {
          text: 'PipeRun CRM',
          webhookUrl: 'https://api.pipe.run/v1/webhooks/webphones/532bea15-2987-4297-8424-650f04bb8df4',
          webhookVersion: 'v1.1'
        }
      }
    }
  },
  mounted () {
    this.getExtension()
    this.loadIntegrationsOptions()
  },
  methods: {
    onSubmit () {
      const form = this.$refs.editExtensionForm
      this.error = null
      if (form.checkValidity()) {
        let paramsToUpdate = {
          id: this.id,
          senha: this.password,
          bina: this.bina,
          first_name: this.firstName,
          last_name: this.lastName,
          email_address: this.email && this.email.length > 0 ? this.email : null,
          gravar_audio: this.recordWrite
        }
        if (this.webhook_url) paramsToUpdate.webhook_cdr_url = this.webhook_url
        if (this.webhook_body_version) paramsToUpdate.webhook_body_version = this.webhook_body_version
        loopback
          .patch('/extensions', paramsToUpdate)
          .then(extension => {
            if (extension) {
              this.assignExtensionProperties(extension)
              $(this.$refs.editExtensionSuccess).modal('show')
            }
          })
          .catch(err => {
            this.parseError(err, errorMessage => {
              this.error = { message: errorMessage }
            })
          })
      } else {
        this.error = {
          message: 'Os campos ramal, senha e permissões são obrigatórios'
        }
      }
    },
    onCancel () {
      this.$router.push({ name: 'extensionList' })
    },
    getExtension () {
      loopback
        .get(`extensions/${this.$route.params.id}`)
        .then(extension => {
          if (extension) {
            this.assignExtensionProperties(extension)
            Object.keys(this.gatewayAttrs).forEach(gateway => {
              if (this.gatewayAttrs[gateway].webhookUrl === extension.webhook_cdr_url &&
                this.gatewayAttrs[gateway].webhookVersion === extension.webhook_body_version) {
                this.integration = gateway
              }
            })
            this.toggleIntegration(this.integration)
          }
        })
        .catch(err => {
          this.error = err
        })
    },
    assignExtensionProperties (extension) {
      this.id = extension.id
      this.extension = extension.ramal
      this.password = extension.senha
      this.bina = extension.bina
      this.firstName = extension.first_name
      this.lastName = extension.last_name
      this.email = extension.email_address
      this.recordWrite = extension.gravar_audio
      this.webhook_cdr_url = extension.webhook_cdr_url
      this.webhook_body_version = extension.webhook_body_version
    },
    loadIntegrationsOptions () {
      this.integrationsOptions = []
      this.addIntegrationsOptions('none')
      this.addIntegrationsOptions('piperun')
    },
    addIntegrationsOptions (gateway) {
      if (this.gatewayAttrs[gateway]) {
        this.integrationsOptions.push({
          text: this.gatewayAttrs[gateway].text,
          value: gateway
        })
      }
    },
    toggleIntegration (gateway) {
      this.webhook_url = this.gatewayAttrs[gateway].webhookUrl
      this.webhook_body_version = this.gatewayAttrs[gateway].webhookVersion
      if (gateway === 'piperun') {
        this.showIntegrationPiperunCollapse = true
      } else {
        this.showIntegrationPiperunCollapse = false
      }
    },
    onChangeIntegration (event) {
      if (event.target) {
        this.toggleIntegration(event.target.selectedOptions[0]._value)
      }
    },
    parseError (error, cb) {
      let errorMessage = 'Oops! Ocorreu algo inesperado :( porfavor entre em contato com suporte@api4com.com'
      if (error) {
        if (error.message) errorMessage = error.message
        if (error.details && error.details.messages) {
          if (error.details.messages.bina) errorMessage = error.details.messages.bina[0]
        }
      }
      cb(errorMessage)
    },
    togglePasswordVisibility () {
      const input = $('#password')
      if (input[0].type === 'password') {
        input[0].type = 'text'
      } else {
        input[0].type = 'password'
      }
    },
    copyToClipboard (event) {
      navigator.clipboard.writeText(event.target.dataset.clipboardText).then(_ => {
        console.log('api4com > copying to clipboard was successful')
      }, err => {
        console.error('api4com > error to copy text:', err)
      })
    }
  },
  watch: {
    bina: function (value) {
      this.bina = value.replace(/[^+0-9]/, '')
    },
    password: function (value, oldValue) {
      if (value) {
        if (value.match(/["'`´ ]/)) {
          this.error = {
            message: 'Não é permitido utilizar espaços ou os seguintes caracteres de acentuação como senha: " \' ` ´'
          }
          this.password = value.replace(/["'`´ ]/, '')
        } else if (oldValue && !oldValue.match(/["'`´ ]/)) {
          this.error = null
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-tabs {
  margin-bottom: 20px;
}
.copy-url-piperun {
  font-weight: bold;
}
.embed-responsive {
  max-width: 800px;
  max-height: 600px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Extension/Edit.vue